import * as Yup from "yup";

export const validationSchema = Yup.object().shape({
  type: Yup.string().required("Type is required!"),
  banner_image: Yup.string().required("Image is required!"),
  is_active: Yup.string().required("Status is required!"),
});
